<template>
  <div class="card flex flex-col overflow-hidden group">
    <!-- Food image -->
    <div class="relative bg-cream-200 h-40 sm:h-44 md:h-48 overflow-hidden">
      <img
        v-if="item.image"
        :src="item.image"
        :alt="item.name"
        class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
      />
      <div
        v-else
        class="w-full h-full flex items-center justify-center text-4xl sm:text-5xl select-none"
      >{{ item.emoji || '🍽️' }}</div>

      <!-- Category badge -->
      <span class="absolute top-3 left-3 badge text-xs">{{ item.category }}</span>

      <!-- Sold out overlay -->
      <div
        v-if="item.soldOut"
        class="absolute inset-0 bg-accent/50 flex items-center justify-center"
      >
        <span class="bg-white text-accent font-bold text-sm px-4 py-1 rounded-full">Sold Out</span>
      </div>
    </div>

    <!-- Card body -->
    <div class="flex flex-col flex-1 p-3 sm:p-4 gap-2">
      <h3 class="font-display font-bold text-accent text-sm sm:text-base leading-snug">{{ item.name }}</h3>
      <p class="text-xs sm:text-sm text-accent/60 leading-relaxed flex-1">{{ item.description }}</p>

      <!-- Price + add button -->
      <div class="flex items-center justify-between pt-2 mt-auto">
        <div>
          <span class="font-display font-bold text-brand text-lg">{{ formatPrice(item.price) }}</span>
          <span class="text-xs text-accent/50 ml-1">Rwf</span>
        </div>
        <button
          class="flex items-center gap-1 bg-brand text-white text-xs sm:text-sm font-semibold px-3 py-1.5 sm:px-4 sm:py-2 rounded-xl hover:bg-brand-600 transition-colors duration-150 disabled:opacity-40 disabled:cursor-not-allowed"
          :disabled="item.soldOut"
          @click="$emit('add-to-cart', item)"
        >
          <PlusIcon class="w-4 h-4" />
          Add
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { PlusIcon } from '@heroicons/vue/24/outline'

export interface MenuItem {
  id: number
  name: string
  description: string
  price: number
  category: string
  emoji?: string
  image?: string
  soldOut?: boolean
}

export default defineComponent({
  name: 'MenuCard',
  components: { PlusIcon },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    }
  },
  emits: ['add-to-cart'],
  setup () {
    const formatPrice = (price: number) =>
      price.toLocaleString('en-RW')
    return { formatPrice }
  }
})
</script>
